import React, { useState, useEffect, useRef } from "react";
import ColorPicker from "./ColorPicker";

const ColorPickerwithmodal = ({ onCancel, value, onChange, onConfirm }) => {
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onCancel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onCancel]);

  return (
    <div className="fixed inset-0 bg-[#02080E80] flex justify-center items-center z-50">
      <div ref={modalRef} className="bg-white p-5 rounded-lg shadow-xl  relative">
        <button
          onClick={onCancel}
          className="absolute top-1 right-1 text-gray-500 hover:text-gray-600 text-[30px]"
        >
          &times;
        </button>


        <div style={{ borderRadius: "10px" }} className="flex justify-center">
          <ColorPicker value={value} onChange={onChange} />
        </div>

        <div className="flex justify-center gap-4 mt-6">
          <button
            onClick={onCancel}
            className="bg-gray-600 text-white  px-6 h-[34px] rounded-lg shadow-lg hover:bg-gray-700 transition duration-300 cursor-pointer"
            style={{ fontFamily: 'Inter,Source Sans Pro, Helvetica, Arial, sans-serif' }}
         >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="bg-green-600 text-white  h-[34px] px-6 rounded-lg shadow-lg hover:bg-green-700 transition duration-300 cursor-pointer"
            style={{ fontFamily: 'Inter,Source Sans Pro, Helvetica, Arial, sans-serif' }}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColorPickerwithmodal;
